import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import BuildCoin from '../images/buildcoin.png';
import Wallet from '../images/wallet.png';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { useState } from 'react';

const ProjectHeader = ({ 
  projectName, 
  type, 
  categoryName,
  customTitle,
  Name,
  Title,
  buildcoins
}) => {
  const navigate = useNavigate();
  const [showBuildCoinsInfo, setShowBuildCoinsInfo] = useState(false);


  return (
    <div className="sticky top-0 z-20 bg-white shadow-sm">
      <div className="flex items-center justify-between border-b border-gray-200 p-4">
        {/* Left Side - Original Content */}
        <div className="flex items-center space-x-4">
          {/* Back Icon */}
          <button onClick={() => navigate(-1)}
            className="hover:bg-gray-100 rounded-full">
            <FontAwesomeIcon icon={faArrowLeft} className="text-gray-600 w-4 h-4" />
          </button>
          
          {/* Project Info */}
          <div className="flex flex-col">
            {customTitle ? (
              <div className="font-bold text-red-500 text-lg">{customTitle}</div>
            ) : (
              <>
                <span className="text-sm font-semibold text-gray-900 capitalize">
                  {projectName ? projectName.toUpperCase() : ''}
                </span>
                <span className="text-md font-semibold text-black-500">
                  {type && <span className="capitalize">{type.toLowerCase()} - </span>}
                  {categoryName || ''}
                </span>
                <p className='text-sm'>
                  {Name} {Title ? <span className='text-xs'>({Title})</span> : ""}
                </p>
              </>
            )}
          </div>
        </div>
        
        {/* Right Side - BuildCoins Info */}
       <div className="flex flex-col items-end">
  <div className="flex items-center">
    <span className="font-regular text-sm ">{buildcoins || 0}</span>
    <img src={BuildCoin} alt="BuildCoin" className="h-5 w-6 ml-0.5" />
  </div>
  <span className="text-sm font-bold">BuildCoins</span>
  <div 
            className="text-xs text-gray-500 border-b border-dotted border-gray-400 cursor-pointer mr-0.5"
            onClick={() => setShowBuildCoinsInfo(true)}
          >
            What's this?
          </div>
</div>
      </div>



      {showBuildCoinsInfo && (
        <>
          {/* Overlay */}
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-50 transition-opacity duration-300"
            onClick={() => setShowBuildCoinsInfo(false)}
          ></div>
          
          {/* Popup from bottom - split into two halves */}
          <div className={`fixed bottom-0 left-0 right-0 bg-white rounded-t-2xl shadow-lg z-50 transform transition-transform duration-300 ease-out ${showBuildCoinsInfo ? 'translate-y-0' : 'translate-y-full'}`}>
            {/* First half with #A04545 background */}
            <div className="bg-[#A04545] text-white rounded-t-2xl p-5">
              <div className="flex justify-between items-center">
                <div className="flex items-center">
                  <img src={BuildCoin} alt="BuildCoin" className="h-8 w-8 mr-2" />
                  <h3 className="text-[#F2BB4D] text-xl font-semibold">BuildCoins</h3>
                </div>
                <button
                  onClick={() => setShowBuildCoinsInfo(false)}
                  className="text-white hover:text-gray-200"
                >
                  <FontAwesomeIcon icon={faTimesCircle} className="w-5 h-5" />
                </button>
              </div>
              
              <div className="mt-4 flex justify-between items-center">
                {/* Left side - Balance information */}
                <div>
                  <p className="text-xl">Use <span className='font-semibold text-[#F2BB4D]'>BuildCoins</span></p>
                  <div className="flex items-center">
                    <span className="text-[10px] ">& get discounts on orders!</span>
                  </div>
                  <p className="text-sm mt-2 ">1 buildcoin equals ₹1</p>
                </div>
                
                {/* Right side - Wallet image */}
                <div className="flex items-center justify-center">
                  <img src={Wallet} alt="Wallet" className="h-26 w-26" />
                </div>
              </div>
              <div className='mb-2 text-xs flex justify-end'>
              *Terms and Conditions apply
              </div>
            </div>
            
            {/* Second half with white background and rounded top */}
            <div className="bg-white p-5 rounded-t-3xl -mt-6">
              <h4 className="text-xl font-bold text-[#A04545] mb-2">WHAT ARE  
               <span className='text-[#F2BB4D]'> BUILDCOINS?</span>
                </h4>
              <p className="pb-3 pr-3  text-sm font-semibold mb-3">
              When you use Brickbucket to purchase building materials, you are rewarded with BuildCoins that you can redeem on the orders you place.
              </p>
              <div className='p-2 flex flex-col rounded-md bg-[#FFEFEF]'>
                <div className='p-2 flex flex-row justify-center'>
                  <img src={BuildCoin} alt="BuildCoin" className="h-7 w-8" />
              <h4 className="text-md font-bold">1 = ₹1</h4>
              </div>
              <li className="text-[12px] font-semibold ">
              Every set of BuildCoins can have an expiry date
              </li>
              <li className="text-[12px] font-semibold  ">BuildCoins are credited in your Brickbucket wallet</li>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ProjectHeader;
